<template>
    <div class="customer-opt-ins">
        <v-card>
            <v-card-title class="pt-2 pb-2">
                <TippTitle position="bottom" :tipp="about" title="Opt-Ins" :loading="loading" :reloadCb="getOptins" />
            </v-card-title>
            <v-card-text class="pt-0">
                <KeineDaten v-if="optins.length <= 0"></KeineDaten>
                <v-data-table
                        v-if="optins.length > 0"
                        hide-default-footer
                        disable-pagination
                        :headers="headers"
                        :items="optins"
                >
                    <template slot="item" slot-scope="props">
                        <tr :class="props.item.class">
                            <td>{{ props.item.type }}</td>
                            <td>{{ props.item.optin_id }}</td>
                            <td>{{ props.item.valid_from | toDatetime }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import KeineDaten from '@/components/customer/KeineDaten.vue';
import TippTitle from '@/components/TippTitle.vue';

export default {
    name: 'Optins',
    components: {
        KeineDaten,
        TippTitle,
    },
    data() {
        return {
            about: 'Zeigt an, welchen Vereinbarungen zur Informationübertragung der Nutzer zugestimmt hat.',
            headers: [{
                text: 'Typ',
                align: 'left',
                sortable: false,
                value: 'type',
            }, {
                text: 'Optin-ID',
                align: 'left',
                value: 'optin_id',
                sortable: false,
            }, {
                text: 'gültig ab',
                value: 'valid_from',
                sortable: false,
            }],
        };
    },
    computed: {
        ...mapGetters('customerDetail', ['optins']),
        ...mapState('customerDetail', {
            loading: state => state.optins.loading,
        }),
    },
    methods: mapActions('customerDetail', ['getOptins']),
};
</script>

<style scoped lang="scss"></style>
